import { cn } from '../../utils'
import { Icon } from '../icon'
import styles from './IndeterminateProgressCircle.module.css'

export interface IndeterminateProgressCircleProps {
  className?: string
  size?: number
}

function IndeterminateProgressCircle({ className, size = 24 }: IndeterminateProgressCircleProps) {
  return <Icon className={cn(styles.spinner, className || '')} glyph="Spinner" size={size} />
}

export default IndeterminateProgressCircle
